import * as API from '@/services/API';

export default {
  get(id) {
    return API.apiClient.get(`/people/${id}`);
  },
  list(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/people/${query}`);
  },
  async save(id, data) {
    if (id == 0) {
      return API.apiClient.post(`/people`, data);
    } else {
      return API.apiClient.put(`/people/${id}`, data);
    }
  },
  async peopleDuplicates(person_id, first_name, surname, dob) {
    return API.apiClient.get(
      `people/people-duplicates?first_name=${first_name}&surname=${surname}&people_id=${person_id}&dob=${dob}`
    );
  },
  paginate(link) {
    return API.apiClient.get(link);
  },
  search(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/people/search${query}`);
  },
  async delete(id) {
    return API.apiClient.delete(`/people/${id}`);
  }
};
